/*
Copyright (c) 2022 COUNTRYSIDE STOVE & CHIMNEY, INC. - ALL RIGHTS RESERVED

UNAUTHORIZED COPYING, MODIFICATION, OR DISTRIBUTION OF THIS SOFTWARE AND ASSOCIATED DOCUMENTATION FILES ("THE SOFTWARE"),
IN ANY MEDIUM IS STRICTLY PROHIBITED
PROPRIETARY AND CONFIDENTIAL
WRITTEN BY BRANDON SULLIVAN <info@empiredistributing.net>, March 2022
*/

import React from 'react';
import {Text, View, StyleSheet, SafeAreaView} from 'react-native';
import {
ListItem,
Button,
Overlay} from 'react-native-elements';

const EmailVerificationPrompt = (props) => {
return (
<SafeAreaView style={{flex: 1, backgroundColor: 'black'}}>
<Overlay
isVisible={props.overlayVisible}
>
<View style={styles.headerView}>
<Text style={styles.headerTitle}>Email Verification Required</Text>
<Text style={styles.headerSubtitle}>You must verify your email address in order to use this app.</Text>
</View>
<ListItem
 containerStyle={styles.listItemContainer}
 bottomDivider={true}>
 <ListItem.Content>
 <ListItem.Title><Text style={styles.listItemTitleText}>Email Address</Text></ListItem.Title>
 <View style={styles.listItemSubtitleView}>
 <Text style={styles.listItemSubtitleText}>{props.email}</Text>
 </View>
 </ListItem.Content>
 </ListItem>
     <View>
          <Button title={'Resend Verification Email'} buttonStyle={{backgroundColor: 'black', marginLeft: 20, marginRight: 20, marginBottom: 10}} containerStyle={{marginTop: 10}} onPress={props.continueBtnAction} />
          <Button title={'Go Back'} buttonStyle={{backgroundColor: '#333333', marginLeft: 20, marginRight: 20, marginBottom: 10}} containerStyle={{marginTop: 10}} onPress={props.backBtnAction}/>
     </View>
  </Overlay>
</SafeAreaView>
)
}

const styles = StyleSheet.create({
     listItemContainer: {
     },
     listItemTitleText: {
     },
     listItemSubtitleText: {
     color: 'gray'
     },
     listItemSubtitleView: {
     flexDirection: 'row',
     paddingTop: 5
     },
     headerView: {
     alignItems: 'center',
     justifyContent: 'center',
     },
     headerTitle: {
     margin: 20,
     fontSize: 20,
     fontWeight: 'bold',
     },
     headerSubtitle: {
     textAlign: 'center',
     margin: 20,
     },
     actionButtonContainer: {
     flexDirection: 'column',
     justifyContent: 'center',
     },
});

export default EmailVerificationPrompt;